"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberRoles = exports.MemberStatuses = void 0;
exports.MemberStatuses = {
    active: "1",
    inactive: "2",
    deleted: "3",
    invited: "4",
};
exports.MemberRoles = {
    admin: "1",
    solution_manager: "2",
    general: "3",
    system: "4",
    guest: "5",
};
